<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group label="Tahun / Generasi">
                    <b-input v-model="hargaTahun.selectedTahun" maxlength="60" required />
                </b-form-group>
            </b-col>
            <b-col md="4" v-if="!isKendaraan">
                <b-form-group label="Harga">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="hargaTahun.harga" name="harga" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="4" v-if="isKendaraan">
                <b-form-group label="Harga Kendaraan">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="hargaTahun.hargaKendaraan" name="hargaKendaraan" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="4" v-if="isKendaraan">
                <b-form-group label="Harga BPKB">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="hargaTahun.hargaBpkb" name="hargaBpkb" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="form-dynamic-deleteWrapper">
            <!-- <b-button variant="dynamicDeleteBtn" name="deleteHargaTahun" @click="$emit('remove', hargaTahun.index)" :disabled="length == 1"><i class="fa fa-times"></i></b-button> -->
            <b-button variant="dynamicActiveBtn"  @click="$emit('aktif', hargaTahun.index)"><i class="fa fa-plus"></i></b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'harga-tahun-non-aktif',
    props: {
        hargaTahun: { type: Object, required: true },
        length: { type: Number, required: true },
        isKendaraan: { type: Boolean, required: true }
    },
    watch: {
        "hargaTahun.harga": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.hargaTahun.harga = result);
        },
        "hargaTahun.hargaKendaraan": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.hargaTahun.hargaKendaraan = result);
        },
        "hargaTahun.hargaBpkb": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.hargaTahun.hargaBpkb = result);
        },
    }
}
</script>